import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_38_95_4W_12_15',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_38_95_4w_12_15_usd',
		},
		primer: 'prd_FMPkBAqsxi9J',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 4,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 31,
		priceMap: {
			USD: 12.15,
		},
		originalPriceMap: {
			USD: 38.95,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 38.95,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		explicitTermsIntervalText: $tc('common.duration.week.dashed.lowercase', 4), // 4-week
		billingSubtitlePeriodText: $tc('common.week_plural', 4), // 4 weeks
		footerPeriodText: $tc('common.duration.week.dashed.lowercase', 4), // '4-week'
		footerIntervalText: $tc('common.duration.week.dashed.lowercase', 4), // '4-week'
		updatedTermsPeriodText: $tc('common.duration.week.first', 4), // 'first 4 weeks'
	}),
}
